// import { LogPage } from "../pages/logs.page"
// import { UserPage } from "../pages/users.page"
// import { ProfilePage } from "../pages/profile.page"
var PageOptions = /** @class */ (function () {
    function PageOptions() {
    }
    PageOptions.setTitle = function (title, desc) {
        var target = $('.page-header');
        var value = "".concat(title);
        if (desc)
            value += " <small>".concat(desc, "</small>");
        target.html(value);
    };
    return PageOptions;
}());
export { PageOptions };
var Pager = /** @class */ (function () {
    function Pager() {
    }
    Pager.setup = function (pageList) {
        var _this = this;
        this.pageList = new Map();
        this.instanceList = new Map();
        pageList.forEach(function (value, key) {
            _this.pageList.set(key, value);
        });
        //this.pageList.set('users', UserPage)
        //this.pageList.set('log_list', LogPage)
        //this.pageList.set('profile', ProfilePage)
        window.onpopstate = function (e) {
            if (e.state) {
                var headParam = /\:([\w\:\@]+)/gm;
                var headerData = window.location.href.split(headParam);
                var headerObject = headerData.length > 1 ? headerData[1].split(':') : [];
                var page = headerObject.length > 0 ? headerObject[0] : "home";
                headerObject.shift();
                var header = {
                    page: page,
                    data: headerObject
                };
                Pager.loadPage(header.page);
            }
        };
    };
    Pager.setBlankPage = function () {
        $('[data-loader]').css('left', $('[data-sidebar]').width());
        $('[data-loader]').show();
        $('#page_content').html('');
        PageOptions.setTitle("", "");
    };
    Pager.loadPage = function (page, updateState) {
        if (updateState === void 0) { updateState = false; }
        if (updateState)
            window.history.pushState({ "html": "", "pageTitle": "" }, "", ":" + page);
        $('[data-loader]').css('left', $('[data-sidebar]').width());
        $('[data-loader]').show();
        $('#page_content').html('');
        PageOptions.setTitle("", "");
        if (this.pageList.has(page)) {
            if (!this.instanceList.has(page)) {
                var fnString = this.pageList.get(page);
                this.instanceList.set(page, new fnString());
            }
            this.instanceList.get(page).run(function () {
                $('[data-loader]').fadeOut();
                $('[data-admin]').removeClass('active');
                $('#content').removeClass('zero-mp');
                $('#page_content').append("<script>App.initComponent()</script>");
            });
        }
        else {
            $.get("sites/404.html", function (data) {
                $('[data-loader]').fadeOut();
                $('[data-admin]').removeClass('active');
                $('#content').addClass('zero-mp');
                $('#page_content').append("".concat(data, "<script>App.initComponent()</script>"));
                console.log("Seite '".concat(page, "' nicht gefunden"));
            });
        }
    };
    Pager.pageList = undefined;
    Pager.instanceList = undefined;
    return Pager;
}());
export { Pager };
